import React from "react";
// import Deliverynote from "./Deliverynote";
import { useLocation } from 'react-router-dom';
import Header from "../../../../Components/Header";
import Shipmentform from "./Create";
import { Helmet } from "react-helmet";

const ShipmentEdit = () => {
  const location = useLocation();
  const { shipment_id } = location.state || {};

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Gate Out - Edit</title>
			</Helmet>
      <Header/>
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Shipmentform shipment_id={shipment_id}  />

      </div>
    </div>

  );
};

export default ShipmentEdit;
